import React from 'react';

const Partners = () => <div>partners</div>;

export default Partners;
